import { connect as reduxConnect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './actions';
import reducer from './reducer';

const mapStateToProps = ({ cache }) => ({ cache });

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      onDeleteInstanceLinks: actions.onDeleteInstanceLinks,
      onDeleteInstancesSurveyResponses:
        actions.onDeleteInstancesSurveyResponses,
      onFetchInstances: actions.onFetchInstances,
      onFetchInstancesQuestions: actions.onFetchInstancesQuestions,
      onFetchInstancesQuestionsOptions:
        actions.onFetchInstancesQuestionsOptions,
      onFetchInstancesResponses: actions.onFetchInstancesResponses,
      onFetchInstanceLinks: actions.onFetchInstanceLinks,
      onFetchInstanceLinksWithInstancesResponses:
        actions.onFetchInstanceLinksWithInstancesResponses,
      onInitializeCache: actions.onInitializeCache,
      onPostInstanceLinks: actions.onPostInstanceLinks,
      onPostInstancesResponses: actions.onPostInstancesResponses
    },
    dispatch
  );

const connect = component =>
  reduxConnect(mapStateToProps, mapDispatchToProps)(component);

export default {
  actions,
  connect,
  reducer
};



// WEBPACK FOOTER //
// ./src/qoc-redux/Cache/index.js